import type { PackEntry } from 'types/shared';
import type { AdSettingsFields } from '../types';

export const countPackCreatives = (pack: PackEntry): number =>
  pack.creatives.reduce(
    (count, id) => count + (typeof id === 'string' && id.length > 0 ? 1 : 0),
    0,
  );

export const countAdSetsContainingFlow = (
  adSets: { name?: string | null }[],
  flowName: string,
): number => {
  if (!flowName) {
    return 0;
  }

  return adSets.filter((adSet) => (adSet.name ?? '').includes(flowName)).length;
};

export const calculatePackFlowAdsCount = (
  creativesCount: number,
  adSetsCount: number,
): number => {
  if (creativesCount < 1 || adSetsCount < 1) {
    return 0;
  }

  return creativesCount * adSetsCount;
};

export const hasPackFlowAds = (
  adSets: { name?: string | null }[],
  flowName: string,
  creativesCount: number,
): boolean => {
  const adSetsCount = countAdSetsContainingFlow(adSets, flowName);
  return calculatePackFlowAdsCount(creativesCount, adSetsCount) > 0;
};

export const filterAdSettingsWithAds = (
  settings: Record<string, unknown> | undefined,
  adSets: { name?: string | null }[],
  creativesCount: number,
): AdSettingsFields => {
  if (!settings || creativesCount < 1) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(settings).filter(([flowName]) =>
      hasPackFlowAds(adSets, flowName, creativesCount),
    ),
  ) as AdSettingsFields;
};

export const getPackDisplayName = (pack: PackEntry, packIndex: number): string => {
  const tag = pack.tag?.trim();
  return tag || `Pack ${packIndex + 1}`;
};
